<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col lg="6">
        <b-form-group :label="`${$t('DOMAIN')} ${!onlyRead ? '*': ''}`">
          <multiselect
            :disabled="onlyRead"
            :placeholder="$t('SELECT_DOMAIN')"
            :selectedLabel="$t('SELECTED')"
            :selectLabel="$t('APPLY')"
            :deselectLabel="$t('CLEAR')"
            v-model="recommendationData.domain" :options="domains" label="name" track-by="id"/>
          <app-validation-description :show="$v.recommendationData.domain.$dirty && $v.recommendationData.domain.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  lg="12">
        <b-form-group :label="`${$t('COMPETENT_ORGAN')}  ${!onlyRead ? '*': ''}`">
          <multiselect
            :disabled="onlyRead"
            :placeholder="$t('SELECT_COMPETENT_ORGAN')"
            :selectedLabel="$t('SELECTED')"
            :selectLabel="$t('APPLY')"
            :deselectLabel="$t('CLEAR')"
            label="name" track-by="id"
            v-model="recommendationData.competent_authorities" :options="competentAuthorities"  :multiple="true"></multiselect>
          <app-validation-description :show="$v.recommendationData.competent_authorities.$dirty && $v.recommendationData.competent_authorities.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  lg="12">
        <b-form-group :label="`${$t('RECOMMENDATION')} ${!onlyRead ? '*': ''}`">
          <b-form-textarea v-if="0"
            :disabled="onlyRead"
            v-model="recommendationData.recommendation"
            type="text"
            :rows="3"
            name="recommendation">
          </b-form-textarea>
          <quill-editor id="recommendation" class="editor" :options="{modules: {toolbar: customToolbar}, placeholder: ''}" v-model="recommendationData.recommendation" :disabled="onlyRead"></quill-editor>
          <app-validation-description :show="$v.recommendationData.recommendation.$dirty && $v.recommendationData.recommendation.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  lg="12">
        <b-form-group :label="`${$t('INDICATOR')} ${!onlyRead ? '*': ''}`">
          <quill-editor id="indicator" class="editor" :options="{modules: {toolbar: customToolbar}, placeholder: ''}" v-model="recommendationData.indicator" :disabled="onlyRead"></quill-editor>
          <app-validation-description :show="$v.recommendationData.indicator.$dirty && $v.recommendationData.indicator.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  lg="12">
        <b-form-group :label="`${$t('GOAL')} ${!onlyRead ? '*': ''}`">
          <quill-editor id="goal" class="editor" :options="{modules: {toolbar: customToolbar}, placeholder: ''}" v-model="recommendationData.goal" :disabled="onlyRead"></quill-editor>
          <app-validation-description :show="$v.recommendationData.goal.$dirty && $v.recommendationData.goal.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  lg="6">
        <b-form-group :label="$t('INITIAL_STATE')">
          <b-form-textarea
            :disabled="onlyRead"
            type="text"
            :rows="3"
            v-model="recommendationData.initial_state"
            name="initial_state">
          </b-form-textarea>
        </b-form-group>
      </b-col>

      <b-col   lg="6">
        <b-form-group :label="`${$t('SPECIFIC_RECOMMENDATION')}`">
          <b-form-textarea
            :disabled="onlyRead"
            type="text"
            :rows="3"
            v-model="recommendationData.specific_recommendation"
            name="specific_recommendation">
          </b-form-textarea>
        </b-form-group>
      </b-col>



      <b-col  lg="12">
        <b-form-group :label="$t('REMARK')">
          <b-form-textarea
            :disabled="onlyRead"
            type="text"
            v-model="recommendationData.remark"
            :rows="3"
            name="remark">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col  lg="6">
        <b-form-group :label="`${$t('COMPLETION_STATUS')} ${!onlyRead ? '*': ''}`">
          <b-form-select  :disabled="onlyRead" text-field="name" value-field="id" :options="statusOptions" v-model="recommendationData.status_complete"></b-form-select>
          <app-validation-description :show="$v.recommendationData.status_complete.$dirty && $v.recommendationData.status_complete.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>

      <b-col  v-if="!onlyRead" lg="6" class="d-flex justify-content-end align-items-center">
        <submit class="pull-right justify-content-end" :loading="loading"></submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Submit from '@/components/app/AppSubmit'
import DatePicker from '@/components/app/datetime/DatePicker'
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import { required } from 'vuelidate/lib/validators'
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import {createRecommendation, updateRecommendation} from "@/services/reccommendation";
import {cloneDeep} from "lodash";
import {toast} from '@/shared/plugins/toastr'
import {C_RECOMMENDATION_VISIBLE} from "@/shared/component_permission";
import DeleteButton from "@/components/app/AppDelete.vue";


export default {
  name: "RecommendationForm",
  props: {
    detail: {
      type: Object
    },
    headerId: {
      type: Number,
    },
    onlyRead: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      required: true
    },
    domainId: {
      type: Number,
    },
    statusComplete: {
      type: Number
    }
  },
  data() {
    return {
      recommendationData: {
        domain: null,
        recommendation: null,
        specific_recommendation: null,
        indicator: null,
        initial_state: null,
        goal: null,
        remark: null,
        status_complete: null,
      },
      C_RECOMMENDATION_VISIBLE,
      loading: false,
      value: [],
      statusOptions: [
        {id: 1, name: this.$t('NOT_FULFILLED')},
        {id: 2, name: this.$t('PARTIALLY_FULFILLED')},
        {id: 3, name: this.$t('FILLED')},
      ],
      languages: [
        { code: 'ba', name: 'BA' },
        { code: 'hr', name: 'HR' },
        { code: 'sr', name: 'SR' },
      ],
    };
  },
  mixins: [getErrorMessage],
  validations:{
    recommendationData: {
      domain: {
        required
      },
      recommendation: {
        required
      },
      goal: {
        required
      },
      indicator: {
        required
      },
      status_complete: {
        required
      },
      competent_authorities: {
        required
      }
    }
  },
  components: {
    DeleteButton,
    AppValidationDescription,
    Submit,
    DatePicker,
    Multiselect
  },
  computed: {
    ...mapGetters('user', ['currentLanguage']),
    ...mapGetters('competentAuthority', ['competentAuthorities']),
    ...mapGetters('recommendation', ['domains']),
    customToolbar() {
      if(this.onlyRead) {
        return  false;
      } else {
        return [
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ 'align': 'left'}, { 'align': 'center'}, {'align': 'right'}, {'align':'justify' }],

        ];
      }
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if(this.$v.$invalid){
        toast({
          'title': this.$t('VALIDATION_FAILED'),
          'message': null,
          'type': 'error',
          'timeout': 6000
        })
        return
      }
      this.loading = true;
      let apiCall;
      const request = {
        domain: this.recommendationData.domain.id,
        language: this.language,
        recommendation: this.recommendationData.recommendation,
        specific_recommendation: this.recommendationData.specific_recommendation,
        competent_authority:  this.recommendationData.competent_authorities ? this.recommendationData.competent_authorities.map((el) => el.id) : [],
        indicator: this.recommendationData.indicator,
        initial_state: this.recommendationData.initial_state,
        goal: this.recommendationData.goal,
        remark: this.recommendationData.remark,
        status_complete: this.recommendationData.status_complete,

      }
      if(this.headerId) {
        apiCall = updateRecommendation(this.headerId, request)
      } else {
        apiCall = createRecommendation(request)
      }
        apiCall.then((response) => {
          toast({
            title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
            message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            type: 'success',
            timeout: 3000
          })
          if(!this.headerId) {
            const { header_id } = response.data;
            this.$emit('reload', header_id);
          } else  {
             this.$emit('success')
          }

        },(error) =>{
          toast({
            title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
            message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
            type: 'error',
            timeout: 6000
          })
        }).finally(() =>{
          this.loading = false;
        })
      }
  },
  watch: {
    detail: {
      handler(detailObject) {
        if(detailObject) {
          this.recommendationData = cloneDeep(detailObject);
        }
      },
      immediate: true
    },
    domainId: {
      handler(value) {
        this.recommendationData.domain = this.domains.find((el) => el.id === value);
      },
      immediate: true,
    },
    statusComplete: {
      handler(value) {
        this.recommendationData.status_complete = value;
      },
      immediate: true,
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect, .multiselect__input, .multiselect__single, .multiselect__tags{
  font-size: 14px;
}
.form-control:disabled, .multiselect--disabled, .multiselect--disabled, .multiselect--disabled .multiselect__tags {
  background-color: #f8f8f859;
  opacity: 0.9;
}
.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select, .multiselect__option--disabled {
  display: none;
}
.multiselect--disabled  .multiselect__tag-icon:after {
  content: none;
}
.editor .ql-editor{
  min-height: 75px;
}
.ql-disabled{
  background-color: #fdfdfd;
}
.ql-container{
  font-size: 15px;
}
.custom-select:disabled {

  color: black;
  background: unset;
  background-color: #fcfcfc;
}
</style>
